export default __webpack_public_path__ + "static/media/php-flat.cb052f09.svg";